import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { ErrorBoundary } from '@beef/react';
import { useIsDesktopDimension } from "../../../hooks/useGetDimensionGroup";
import { Mobile } from "./components/Mobile";
import { Desktop } from "./components/Desktop";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var Footer = /*#__PURE__*/memo(function (_ref) {
  var data = _ref.data,
    subscribeEmailURL = _ref.subscribeEmailURL,
    subscribeEmailTextAgreementURL = _ref.subscribeEmailTextAgreementURL,
    mobileAppClickCallback = _ref.mobileAppClickCallback;
  var isDesktop = useIsDesktopDimension();
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("footer", {
    className: cn('footer'),
    role: "contentinfo"
  }, isDesktop ? /*#__PURE__*/React.createElement(Desktop, _extends({
    subscribeEmailTextAgreementURL: subscribeEmailTextAgreementURL,
    subscribeEmailURL: subscribeEmailURL
  }, data)) : /*#__PURE__*/React.createElement(Mobile, _extends({}, data, {
    mobileAppClickCallback: mobileAppClickCallback,
    subscribeEmailTextAgreementURL: subscribeEmailTextAgreementURL,
    subscribeEmailURL: subscribeEmailURL
  }))));
});
Footer.displayName = Footer.name;